import {CategoriesI18n} from '@/locales/base.message.locales';

export const categories: CategoriesI18n = {
  title: '<p style="font-weight: bold;">CATEGORIES</p>',
  flag: 'Places tagged by users with a problem related to this category',
  go_to_challenges: 'Go to Challenges',
  search: 'Search Challenge',
  loading: 'Loading categories...',
  loading_single: 'Loading...',
  text: `
     <p class="text-justify">
     The <span class="primary--text font-weight-bold">Sustainable Development Goal</span> (SDGs) are a collection of 17 global goals, which are an urgent call for action by all countries - developed and developing - in a global partnership established by the UN in the 2030 Agenda. We promote innovation by mapping projects and causes that need to happen within these categories and we are committed to mobilizing a network of local talents together with global partnerships, to perform on a large scale and with a high impact, which many consider impossible.
    </p>`
};
